import { createFinishStepContent } from '../FinishStepContent';
import { closeSidebarPanel, openAnalyticsSubmenu } from '../sidebarHelpers';

const exportAnalytics = (baseUrl, navigate, user) => {
  return {
    id: 'exportAnalytics',
    title: 'Export analytics',
    steps: [
      {
        selector: `[data-tour="analyticsLink"]`,
        content: (
          <p>
            Over time as your communication with your customers builds up, you can download reports and analyze them in
            Excel, for example. Click on the "Analytics" section in the navigation.
          </p>
        ),
      },
      {
        selector: '[data-tour="reportsLink"]',
        content: <p>Click on the "Exports" in the navigation.</p>,
        actionBefore: () => openAnalyticsSubmenu('[data-tour="reportsLink"]'),
      },
      {
        actionBefore: () => {
          closeSidebarPanel();
          navigate(`${baseUrl}/reports`, true);
        },
        selector: '[data-tour="newElementBtn"]',
        content: <p>Click here to schedule a new report.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/reports/new`, true),
        selector: '[data-tour="reportName"]',
        stepInteraction: true,
        content: <p>Give your report a name so that you know what this is about.</p>,
      },
      {
        selector: '[data-tour="reportType"]',
        content: <p>Here you can choose whether this will be one time report or you want to get it on a regular basis.</p>,
      },
      {
        selector: '[data-tour="reportPeriod"]',
        stepInteraction: true,
        content: <p>Select a period for the report data.</p>,
      },
      {
        selector: '[data-tour="reportScope"]',
        content: <p>In the Scope section, you can select what type of Releva element to get a report for.</p>,
      },
      {
        selector: '[data-tour="reportScopeSelect"]',
        content: <p>Click on the scope dropdown to see the available options.</p>,
      },
      {
        selector: '[data-tour="reportScopeSelect"]',
        stepInteraction: true,
        content: <p>For example, you can choose to download a report of all your product blocks or email campaigns.</p>,
        actionBefore: async () => {
          document.querySelector('[data-tour="reportScopeSelect"] input')?.click();
          await new Promise((resolve) => setTimeout(resolve, 300));
        },
      },
      {
        selector: '[data-tour="reportSelection"]',
        content: (
          <p>
            Here you can choose whether you want a report for all emails or you want to manually pick the ones you're
            interested in. Choose them from the dropdown menu.
          </p>
        ),
      },
      {
        selector: '[data-tour="reportRecipients"]',
        content: (
          <p>
            Last but not least you can send the report to multiple recipients once it's ready. By default, we will send
            you a download link via email where you can download the actual data in CSV format.
          </p>
        ),
      },
      {
        selector: '[data-tour="reportSaveBtn"]',
        content: <p>Click "Save" if you want your report to be sent right away.</p>,
      },
      {
        actionBefore: () => navigate(`${baseUrl}/guide`, true),
        selector: '[data-tour="userGuideHeading"]',
        content: createFinishStepContent(),
      },
    ],
    isComplete: !!user.userActions.find((a) => a.action === 'taskCompleted' && a.context.task === 'exportAnalytics'),
  };
};

export default exportAnalytics;
